import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const AddSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default AddSVG;
